import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import ServicesItem from "../components/TripsItem";
import Helmet from "../components/Helmet";

import CommonSection from "../components/CommonSection";
import jwtDecode from "jwt-decode";
import { getTrips } from "../util/api";

const Services = () => {
  useEffect(() => {
    getUser();
  }, []);

  const [userId, setUserId] = useState("");
  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Pending");

  const getUser = async () => {
    let token = localStorage.getItem("token");
    const user = jwtDecode(token);
    console.log("token", user);
    const val = {
      userId: user.UserId,
      status: "Pending",
    };
    getTrips(val).then((res) => {
      console.log(res);
      setData(res);
    });
    setUserId(user.UserId);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    const val = {
      userId: userId,
      status: event.target.value,
    };
    getTrips(val).then((res) => {
      console.log("res", res);
      setData(res);
    });
  };
  return (
    <Helmet title="Services">
      <section className="pt-0">
        <CommonSection title="Trips" />
        <Container>
          <Row>
            <ServicesItem
              userId={userId}
              data={data}
              handleOptionChange={handleOptionChange}
              selectedOption={selectedOption}
            />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Services;
